import { useOnIntersectingChange } from '@shared/utils/hooks/useOnIntersectingChange';
import React, { useCallback, useRef } from 'react';
import { useValuePropCardContext } from './ValuePropCard.provider';
import { StyledCardPhoto, StyledCardTileContainer } from './ValuePropCard.styles';
import { ValuePropCardProps } from './ValuePropCard.types';
import { addRendition } from '@shared/utils/photoRendition';

const DEFAULT_IMAGE = 'https://withjoy.com/assets/public/apps/registry/custom-item-default.svg';

export const ValuePropCard: React.FC<ValuePropCardProps> = React.memo(props => {
  const { id, desktopImageUrl, mobileImageUrl, onClick } = props;

  const mobileImage = `url('${addRendition({ url: mobileImageUrl || DEFAULT_IMAGE, renditionSize: 'medium', isProduct: true })}')`;
  const desktopImage = `url('${addRendition({ url: desktopImageUrl || DEFAULT_IMAGE, renditionSize: 'medium', isProduct: true })}')`;

  const { markCardAsViewed } = useValuePropCardContext();
  const cardContainerRef = useRef(null);

  const onIntersectingTriggerPointEl = useCallback(
    (isIntersecting: boolean) => {
      if (isIntersecting && cardContainerRef.current) {
        markCardAsViewed(id);
      }
    },
    [id, markCardAsViewed],
  );

  useOnIntersectingChange(cardContainerRef, onIntersectingTriggerPointEl);

  return (
    <StyledCardTileContainer
      ref={cardContainerRef}
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'auto'}
    >
      <StyledCardPhoto
        backgroundImage={[mobileImage, null, null, desktopImage]}
        backgroundSize={[!mobileImageUrl ? '50%' : 'contain', null, null, !desktopImageUrl ? '50%' : 'contain']}
      />
    </StyledCardTileContainer>
  );
});
